import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {CalculatorPage} from '../calculator/calculator';

/**
 * Generated class for the CalculatorsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-calculators',
  templateUrl: 'calculators.html',
})
export class CalculatorsPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad CalculatorsPage');
  }
goToPageName(pageName){
  if(pageName=='emi'){
    this.navCtrl.push(CalculatorPage)
  }
}
}



// WEBPACK FOOTER //
// ./src/pages/calculators/calculators.ts